/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetZipCodesParams,
  GetZipFromCoordinatesErrorResponse,
  GetZipFromCoordinatesResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getZipCodes = (params?: GetZipCodesParams, signal?: AbortSignal) => {
  return api<GetZipFromCoordinatesResponse>({
    url: `/api/zip-codes`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetZipCodesQueryKey = (params?: GetZipCodesParams) => {
  return [`/api/zip-codes`, ...(params ? [params] : [])] as const;
};

export const getGetZipCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof getZipCodes>>,
  TError = GetZipFromCoordinatesErrorResponse,
>(
  params?: GetZipCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getZipCodes>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetZipCodesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getZipCodes>>> = ({ signal }) =>
    getZipCodes(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getZipCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetZipCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getZipCodes>>>;
export type GetZipCodesQueryError = GetZipFromCoordinatesErrorResponse;

export function useGetZipCodes<
  TData = Awaited<ReturnType<typeof getZipCodes>>,
  TError = GetZipFromCoordinatesErrorResponse,
>(
  params: undefined | GetZipCodesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getZipCodes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZipCodes>>,
          TError,
          Awaited<ReturnType<typeof getZipCodes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetZipCodes<
  TData = Awaited<ReturnType<typeof getZipCodes>>,
  TError = GetZipFromCoordinatesErrorResponse,
>(
  params?: GetZipCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getZipCodes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZipCodes>>,
          TError,
          Awaited<ReturnType<typeof getZipCodes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetZipCodes<
  TData = Awaited<ReturnType<typeof getZipCodes>>,
  TError = GetZipFromCoordinatesErrorResponse,
>(
  params?: GetZipCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getZipCodes>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetZipCodes<
  TData = Awaited<ReturnType<typeof getZipCodes>>,
  TError = GetZipFromCoordinatesErrorResponse,
>(
  params?: GetZipCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getZipCodes>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetZipCodesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
